





















































































































































import { Component, Vue } from 'vue-property-decorator';
import { vxm } from '../store';

@Component({
  computed: {
    isLogin: () => vxm.login.isLogin,
  },
})
export default class extends Vue {
  private tabVal = 1;
}
